// src/utils/invoiceBalance.js
// acctstmt-5b3e9f14 -- Seam 10 (Customer Statements with Account Credits)
//
// ⚠️ TWIN — DO NOT EDIT ONE COPY ALONE. This is a byte-identical client mirror of
// computeInvoiceBalance in functions/index.js (marker creditlock-9f3a2c17). The
// React bundle cannot import from functions/ (it is CommonJS, server-only), so the
// money math is duplicated on purpose — the same accepted-twin situation as the
// advanceRecurrence engine (three copies) and quoteSchema. Any change to the logic
// here MUST be made in functions/index.js too, and vice versa. Both copies are
// pinned by the shared fixture functions/scripts/fixtures/invoiceBalanceCases.json,
// which the server test (functions/scripts/testComputeInvoiceBalance.js) and the
// client test (src/utils/invoiceBalance.test.js) both run against — a divergence
// fails a test rather than silently drifting. See BACKLOG twin-pair note.
//
// The ONE authoritative reader of an invoice's true balance. NEVER trusts a stored
// `balanceDue` (several creation paths omit it) — always derives it. amountPaid
// precedence: a finite stored `amountPaid` wins (the running ledger maintained by
// buildInvoicePaymentUpdate, which respects a stored 0 after a full refund);
// otherwise sum paymentHistory[].amount. Returns the SIGNED balance (an
// overpaid/over-credited invoice reads negative); only the sub-cent residue snaps
// to 0, negatives are NOT clamped — callers clamp for display as they see fit.
export function computeInvoiceBalance(invoice) {
    const round2 = (x) => Math.round(x * 100) / 100;
    const total = round2(Number(invoice.total) || 0);

    let amountPaid;
    if (typeof invoice.amountPaid === 'number' && Number.isFinite(invoice.amountPaid)) {
        amountPaid = round2(invoice.amountPaid);
    } else {
        const hist = Array.isArray(invoice.paymentHistory) ? invoice.paymentHistory : [];
        amountPaid = round2(hist.reduce((sum, p) => sum + (Number(p && p.amount) || 0), 0));
    }

    let balanceDue = round2(total - amountPaid);
    if (Math.abs(balanceDue) < 0.01) balanceDue = 0;

    return { amountPaid, balanceDue };
}
